import { useMemo } from "react";
import { ReportMetadataLibrary, ReportMetadataItem } from "../../models/pageModels/ReportLibrary";

export const useReportSelectionRules = (
  selectedReports: string[],
  reports: ReportMetadataLibrary
) => {
  return useMemo(() => {
    if (selectedReports.length === 0) return { canGroup: false, canUngroup: false };

    const selectedItems: ReportMetadataItem[] = [];

    const collect = (item: ReportMetadataLibrary["bookmarkedReports"][number]) => {
      if (item.type === "group") {
        item.reports.forEach(r => {
          if (selectedReports.includes(r.id)) selectedItems.push(r);
        });
      } else {
        if (selectedReports.includes(item.id)) selectedItems.push(item);
      }
    };

    reports.bookmarkedReports.forEach(collect);
    reports.recentReports.forEach(r => {
      if (selectedReports.includes(r.id)) selectedItems.push(r);
    });

    const hasItems = selectedItems.length > 0;

    return {
      canGroup: hasItems,
      canUngroup: hasItems && selectedItems.every(r => !!r.reportGroupId),
    };
  }, [selectedReports, reports]);
};